module.exports = __webpack_public_path__ + "static/img/motivation.20bc6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/motivation.png
// module id = Wm7M
// module chunks = 1